import anime from 'animejs';
import Form from 'components/form/Form';
import { durations } from 'components/menu/motion';
import scroll from 'core/scroll';
import { EASE_IN, EASE_OUT, frameToMs } from 'helpers/easings';
import Component, { forceArray } from 'navigation/component/Component';
import store from 'store/store';
class Search extends Component {
    name = 'search';
    _opened = false;
    openStart = false;
    motions = [];
    get opened() {
        return this._opened;
    }
    set opened(value) {
        this._opened = value;
        this.el.classList.toggle('opened', value);
    }
    opening = false;
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            form: ['.search-form', Form]
        };
    }
    bindEvents(add) {
        store.drawer.toggleListener(add, this.onDrawerChange);
        this.refs.productLinks?.forEach((link) => {
            link.addEventListener('mouseover', (e) => this.onItemOver(e, 'product'));
            link.addEventListener('mouseout', (e) => this.onItemOut(e, 'product'));
        });
        this.refs.highlightLinks?.forEach((link) => {
            link.addEventListener('mouseover', (e) => this.onItemOver(e, 'highlight'));
            link.addEventListener('mouseout', (e) => this.onItemOut(e, 'highlight'));
        });
        this.refs.popularLinks?.forEach((link) => {
            link.addEventListener('mouseover', (e) => this.onItemOver(e, 'popular'));
            link.addEventListener('mouseout', (e) => this.onItemOut(e, 'popular'));
        });
        this.refs.productList?.addEventListener('mouseout', (e) => this.onListOut(e, 'product'));
        this.refs.highlightList?.addEventListener('mouseout', (e) => this.onListOut(e, 'highlight'));
        this.refs.popularList?.addEventListener('mouseout', (e) => this.onListOut(e, 'popular'));
        this.modules.form?.on('submitted', this.onSubmitted);
    }
    onSubmitted = () => {
        store.drawer.set(null);
    };
    onItemOver = (e, type) => {
        const target = e.currentTarget;
        for (const link of this.refs[type + 'Links']) {
            link.classList.remove('active');
            link.classList.add('inactive');
        }
        target.classList.remove('inactive');
        target.classList.add('active');
    };
    onItemOut = (e, type) => {
        const target = e.currentTarget;
        target.classList.remove('active');
        target.classList.add('inactive');
    };
    onListOut = (e, type) => {
        for (const link of this.refs[type + 'Links']) {
            link.classList.remove('active');
            link.classList.remove('inactive');
        }
    };
    onDrawerChange = (drawer) => {
        this.cancelMotions();
        if (drawer === this.name) {
            this.open();
        }
        else {
            if (this.openStart || this.opened || this.opening)
                this.close();
        }
    };
    cancelMotions = () => {
        this.el.querySelector('input')?.blur();
        this.motions.forEach((motion) => {
            if (motion)
                motion.pause();
        });
        this.motions = [];
    };
    open = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const query = urlParams.get('q');
        document.body.classList.add('header__search');
        this.refs.fieldInput.value = query;
        scroll.lock();
        this.opening = true;
        this.openStart = true;
        const m = anime({
            targets: this.el,
            clipPath: {
                value: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
                duration: durations.FIRST_PANEL_TRANSLATE_IN,
                easing: EASE_OUT
            },
            opacity: {
                value: 1,
                duration: durations.FIRST_PANEL_OPACITY_IN / 2,
                easing: 'linear'
            },
            begin: () => {
                this.refs.inner.style.opacity = '1';
                this.el.querySelector('input')?.focus();
            },
            complete: () => {
                this.opened = true;
                this.opening = false;
                this.openStart = false;
            }
        });
        const m1 = anime({
            targets: this.refs.inner,
            translateY: {
                value: 0,
                duration: durations.FIRST_PANEL_TRANSLATE_IN,
                easing: EASE_OUT
            }
        });
        const m2 = anime({
            targets: [forceArray(this.refs.popularLinks), forceArray(this.refs.highlightLinks), forceArray(this.refs.productLinks)].flat(),
            translateY: {
                value: [-5, 0],
                duration: durations.FIRST_PANEL_TRANSLATE_IN,
                easing: EASE_OUT,
                delay: anime.stagger(frameToMs(1), { start: frameToMs(5) })
            },
            opacity: {
                value: [0, 1],
                duration: durations.FIRST_PANEL_OPACITY_IN,
                easing: 'linear',
                delay: anime.stagger(frameToMs(2), { start: frameToMs(5) })
            }
        });
        this.motions.push(m, m1, m2);
    };
    close = () => {
        // this.el.querySelector('input')?.blur()
        const m = anime({
            targets: this.el,
            clipPath: {
                value: 'polygon(0 0, 100% 0%, 100% 80%, 0 80%)',
                duration: durations.FIRST_PANEL_TRANSLATE_OUT,
                easing: 'easeInSine'
            },
            opacity: {
                value: 0,
                duration: durations.FIRST_PANEL_OPACITY_OUT,
                delay: (durations.FIRST_PANEL_OPACITY_OUT) / 2,
                easing: 'linear'
            },
            complete: () => {
                document.body.classList.remove('header__search');
                this.opened = false;
                this.refs.inner.style.opacity = '';
                scroll.unlock();
                this.el.querySelector('input')?.blur();
            }
        });
        const m1 = anime({
            targets: this.refs.inner,
            translateY: {
                value: -30,
                duration: frameToMs(10),
                easing: EASE_IN
            },
            opacity: {
                value: 0,
                duration: frameToMs(10),
                easing: 'linear'
            }
        });
        this.motions.push(m, m1);
    };
}
export default Search;
